<template>
  <div id="login" class="d-flex">
    <div class="col-gauche">
      <div class="page-content">
        <div class="page-single-content">
          <!-- <img src="../img/sud-thd-logo-blanc.png" class="logo-sud-thd" /> -->
          <div class="img-login">
            <img
              src="../img/macs-big-transparent.png"
              alt="img"
              style="max-width:512px !important;"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-droite">
      <div class="page-single-content">
        <div class="content-login">
          <div class="row">
            <div class="col-md-8 content-form-login">
              <div>
                <h1>Mot de passe oublié</h1>
                <p class="text-muted">Entrez l'adresse email de votre compte</p>
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon icon="envelope"></font-awesome-icon>
                </span>
                <b-form-input
                  v-model="email"
                  type="text"
                  placeholder="Adresse email"
                ></b-form-input>
              </div>
              <div class="col-xs-12 no-padding marginTop">
                <b-button
                  type="button"
                  class="btn-block"
                  variant="warning"
                  @click="forgotPassword()"
                >
                  <font-awesome-icon icon="arrow-right"></font-awesome-icon>
                  Envoyer
                </b-button>
              </div>
              <div class="col-xs-12 no-padding marginTop">
                Retourner à l'<router-link to="/login"
                  >identification</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "ForgotPassword",
  methods: {
    forgotPassword() {
      Vue.axios
        .post(window.urlapi + "password", { email: this.email })
        .then((response) => {
          if (response.data.success == true) {
            Vue.prototype.$awn.success(response.data.message.toString());
          }
        });
    },
  },
  data: () => ({
    email: "",
  }),
};
</script>

<style></style>
